// Turns Supabase/PostgREST errors into a Spanish message for the UI.
// Business errors raised by the database carry: message = code, details = Spanish text.

interface PgError {
  message?: string
  details?: string | null
  code?: string
}

const GENERIC: Record<string, string> = {
  '42501': 'No tiene permisos para esta acción.',
  PGRST301: 'Su sesión venció. Inicie sesión de nuevo.',
  'Failed to fetch': 'Sin conexión con el servidor. Revise su internet.',
}

export function errorMessage(e: unknown): string {
  if (!e) return 'Error desconocido.'
  if (typeof e === 'string') return e
  const err = e as PgError
  if (err.code === 'P0001' && err.details) return err.details
  if (err.code && GENERIC[err.code]) return GENERIC[err.code]
  if (err.message && GENERIC[err.message]) return GENERIC[err.message]
  if (err.message && /fetch|network/i.test(err.message)) return GENERIC['Failed to fetch']
  return err.message ?? 'Error desconocido.'
}

/** Throws the Supabase error so callers can use try/catch with errorMessage(). */
export function unwrap<T>(res: { data: T; error: unknown }): T {
  if (res.error) throw res.error
  return res.data
}
